<template>
  <span style="margin-right:5px">
    <el-button type="warning" :size="btnSize" @click="showDialog()"
      icon="el-icon-edit" :loading="loading">Edit</el-button
    >

    <el-dialog
      :title="'Edit Monthly fee Credit'"
      :visible.sync="dialogVisible"
      :width="device === 'mobile' ? '95%' : '40%'"
      top="5vh"
      :modal="false"
    >
      <el-form
        :model="formData"
        ref="updateCreditForm"
        label-width="150px"
        size="small"
        :rules="formDataRule"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-form-item label="Type" prop="type">
          <el-select v-model="formData.type">
            <el-option label="Debit" value="debit"></el-option>
            <el-option label="Credit" value="credit"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Amount" prop="amount">
          <el-input
            type="number"
            v-model="formData.amount"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Description" prop="description">
          <el-input type="textarea" v-model="formData.description"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitUpdateCredit()"
         :loading="submitting" >Update</el-button
        >
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { getCreditRecord, updateCreditRecord } from  '@/api/monthlyfeecredits'
export default {
  props: {
    uid: String,
    btnSize: {
      type: String,
      default: "small",
    }
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      formData: {
        amount: 0,
        description: "",
        bankholderID: "",
        type: "credit",
      },
      formDataRule: {
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    showDialog() {
      this.getCredit();
    },
    getCredit(){
      this.loading = true
      getCreditRecord(this.uid).then(({result, data})=>{
        this.loading = false
        if(result){
          this.formData.amount = data.amount
          this.formData.type = data.type
          this.formData.bankholderID = data.bankholderID
          this.formData.description = data.description
          this.dialogVisible = true;
        }
      })
    },
    submitUpdateCredit(){
      this.$refs.updateCreditForm.validate(valid=>{
        if(valid){
          this.submitting = true
          updateCreditRecord(this.uid, this.formData).then(({result})=>{
            this.submitting = false
            if(result){
              this.dialogVisible = false
              this.$notify({
                title: 'Success',
                message: `Update Credit successfully`,
                type: 'success',
                duration: 2000
              });
              this.$emit('submited')
            }
          })
        }
      })
    }
  },
};
</script>

<style>
</style>